<template>
  <el-select
    v-model="result"
    :multiple="fields.compType === 5"
    :placeholder="type === 'readOnly' ? '暂无数据' : '请选择'"
    style="width: 100%"
    clearable
    filterable
    :filter-method="filterMethod"
    :disabled="type === 'readOnly'"
    remote
    :size="size"
    reserve-keyword
    @change="change"
    @visible-change="visibleChange"
  >
    <el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.projectId" class="projectOptions">
      <option-view :item="item" />
    </el-option>
  </el-select>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import { debounce } from 'throttle-debounce'
import optionView from './optionView'
export default {
  name: 'ProjectId',
  components: {
    optionView
  },
  props: {
    value: [String, Array],
    fields: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'medium'
    }
  },
  data() {
    return {
      result: this.value,
      options: [],
      optionsCopy: []
    }
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  watch: {
    value: {
      handler: function(newval, oldval) {
        if (newval === 2) {
          this.result = newval
        }
      },
      deep: true
    }

  },
  methods: {
    change() {
      this.$emit('input', this.result)
      this.$emit('change', this.result)
    },
    visibleChange(val) {
      if (!val) {
        this.options = JSON.parse(JSON.stringify(this.optionsCopy))
      }
    },
    optionsInit(search = '') {
      const statisticsTmp = this.fields.bpmConfig?.statisticsTmp
      const p = {
        method: statisticsTmp.requestMethodStr,
        url: statisticsTmp.interfacePath
      }
      const objData = statisticsTmp.variables ? JSON.parse(statisticsTmp.variables) : {}
      objData.userId = this.userInfo.externalUserId
      objData.search = search
      objData.isShowAll = this.type === 'readOnly'

      if (statisticsTmp.requestMethodStr === 'POST') {
        p.data = objData
      } else if (statisticsTmp.requestMethodStr === 'GET') {
        p.params = objData
      }
      axios(p).then((res) => {
        if (res && res.data && res.data.code === '200' && res.data.data && res.data.data instanceof Array) {
          this.options = res.data.data
          if (search === '') {
            // 第一次请求，复制一份
            this.optionsCopy = JSON.parse(JSON.stringify(res.data.data))
          }
          this.$emit('setOptions', this.options)
        }
      }).catch((e) => {

      })
    },
    filterMethod: debounce(500, function(val) {
      this.optionsInit(val)
    })

  },
  created() {

  },
  mounted() {
    this.optionsInit()
  },
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {}
}
</script>
<style lang="scss" scoped>
.projectOptions{
  height: auto;
  line-height: 22px;
  padding-bottom: 10px;
  padding-top: 10px;
}
.projectNo_readOnly{
  ::v-deep .el-input.is-disabled .el-input__inner{
    background: #fff;
    color: #2c3e50;
    cursor:auto;
  }
  ::v-deep  .el-tag.el-tag--info{
    color: #2c3e50;
  }
   ::v-deep .el-select__caret{
    display: none;
  }
  ::v-deep .el-input-number__decrease,::v-deep .el-input-number__increase{
    display: none;
  }
}

</style>
